module.exports = __webpack_public_path__ + "static/img/matches.cb4e7c9b.svg";